export default "__VITE_ASSET__BXtKZYM0__"